<template>
  <div class="role-management">
    <div class="search-top">
      <el-button type="primary" size="small" icon="el-icon-circle-plus-outline" @click="goToAdd">新增角色</el-button>
    </div>
    <div style="clear: both"></div>

    <div class="table-box" v-if="tableData.length>0">
      <div class="table-kuang" v-for="(item,index) in tableData" :key="index">
        <div class="title-message">
          <div class="title-name">{{item.roleName}}</div>
          <div>
            <img src="@/assets/edit.png" class="mr10 pointer" @click="goToEdit(item)" />
            <img src="@/assets/delete.png" class="pointer" @click="isDelete(item)" />
          </div>
        </div>
        <div class="role-box">
          <div v-for="(item2,index2) in item.roleDescList" :key="index2" class="role-name">
            {{item2}}
            
          </div>
          
          <el-tooltip class="item" effect="dark" :content="item.roleDesc" placement="top" v-if="item.roleDescList.length>=14">
            <div class="morethan">
              <img src="@/assets/morethan.png" class="more-img" />
              <div class="names">更多</div>
            </div>
          </el-tooltip>
        </div>
      </div>
    </div>

    <el-empty description="暂无数据" v-else class="mt30"></el-empty>
    <div class="page-box" v-if="listQuery.total>6">
      <el-pagination
        background
        @current-change="getTableDataList"
        :current-page.sync="listQuery.pageNum"
        :page-size="listQuery.pageSize"
        layout="total, prev, pager, next, jumper"
        :total="listQuery.total"
      >
      </el-pagination>
    </div>
    <!-- 编辑角色信息弹窗  -->
    <el-dialog
      :visible.sync="editRoleDialogVisible"
      width="600px"
      :destroy-on-close="true"
    >
      <span slot="title" v-if="isAdd == true"> 新增角色信息 </span>
      <span slot="title" v-if="isAdd == false"> 编辑角色信息 </span>
      <editRole
        v-if="editRoleDialogVisible"
        :is-add="isAdd"
        :edit-role-id="editRoleId"
        :edit-role-name="editRoleName"
        ref="editRole"
        @success="editSuccessHandel"
      ></editRole>
      <div slot="footer" class="dialog-footer">
        <el-button @click="editRoleDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="confirmEditHandle">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { rolePage, deleteRole,deleteRolePd } from "@/api/authorityManagement";
import editRole from "./components/editRole.vue";
export default {
  components: {
    editRole,
  },
  data() {
    return {
      listQuery: {
        pageNum: 1,
        pageSize: 6,
        total: 0,
      },
      // total: 0,
      tableData: [],
      isAdd: true, //编辑类型 true 新增 false 修改
      editRoleDialogVisible: false, //编辑界面弹窗是否显示
      editRoleId: "", //需要编辑的角色ID
      editRoleName: "", //需要编辑的角色Name
    };
  },
  mounted() {
    this.getTableDataList();
  },
  methods: {
    //编辑操作成功
    editSuccessHandel() {
      this.getTableDataList();
      this.editRoleDialogVisible = false;
    },
    goToAdd() {
      // this.$router.push({
      //   name: "addRole",
      // });
      this.editRoleId = "";
      this.editRoleName = "";
      this.isAdd = true;
      this.editRoleDialogVisible = true;
    },
    goToEdit(row) {
      // this.$router.push({
      //   name: "editRole",
      //   query: {
      //     roleId: row.roleId,
      //     roleName: row.roleName,
      //   },
      // });
      this.isAdd = false;
      this.editRoleId = row.roleId;
      this.editRoleName = row.roleName;
      this.editRoleDialogVisible = true;
    },
    //确定编辑事件
    confirmEditHandle() {
      this.$refs.editRole.editRoles();
    },

    //查询列表
    getTableDataList(val) {
      this.listQuery.pages = val;
      this.getTableData();
    },
    getTableData() {
      rolePage(this.listQuery).then((res) => {
        if (res.code == 1) {
          this.tableData = res.data.list || [];
          if(this.tableData.length>0) {
            this.tableData.forEach(item=>{
              let roleDescList = item.roleDesc.split(",")
              if(roleDescList.length>14) {
                item.roleDescList = roleDescList.slice(0,14)
              } else {
                item.roleDescList = roleDescList
              }
            })
          }
          
          this.listQuery.total = res.data.total;
        } else {
          // this.$message.error(res.msg);
        }
      });
    },
    isDelete(row) {
      deleteRolePd({roleId: row.roleId}).then(res=>{
        if(res.code==1) {
          if(res.data == true) {
            this.deleteOption(row)
          } else {
            this.$message.warning("该角色有关联用户，不可删除！")
          }
        }
      })
    },
    deleteOption(row) {
      this.$confirm("确定要删除此角色？", "删除角色", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          let data = {
            roleId: row.roleId,
          };
          deleteRole(data).then((res) => {
            if (res.code == 1) {
              this.$message.success("删除成功!");
              this.getTableData();
            } else {
              // this.$message.error(res.msg);
            }
          });
        })
        .catch(() => {
          // this.$message({
          //   type: "info",
          //   message: "已取消删除",
          // });
        });
    },
  },
};
</script>

<style lang="less" >
.role-management {
  .search-top {
    height: 40px;
    float: right;
  }
  .option-list-box {
    display: flex;
    span {
      cursor: pointer;
    }
  }
  .page-box {
    text-align: right;
  }
  .ml10r {
    margin-left: 10px;
  }
}
.el-tooltip__popper{
  max-width: 800px;
}


.table-box {
  display: flex;
  flex-wrap: wrap;
  .table-kuang {
    width: 530px;
    height: 203px;
    box-shadow: 0px 0px 10px 0px rgba(0,43,66,0.18);
    opacity: 0.77;
    border-radius: 5px;
    margin: 10px 10px 6px 10px;

    overflow: hidden;

    .title-message {
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 8px 20px 8px 20px;
      border-bottom: 1px solid #DCDEE2;
      .title-name {
        font-size: 18px;
        font-family: Microsoft YaHei;
        font-weight: bold;
        color: #333333;
      }
    }

    .role-box {
      padding: 16px 0 20px 20px;
      display: flex;
      align-items: center;
      flex-wrap: wrap;
      
      .role-name {
        padding: 7px 12px 7px 12px;
        background: #F0F5FC;
        border-radius: 14px;
        margin: 0 10px 10px 0;
        font-size: 14px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #25A1E3;
      }
    }

    .morethan {
      width: 80px;
      height: 28px;
      background: #25A1E3;
      border-radius: 14px;
      font-size: 14px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #FFFFFF;
      display: flex;
      align-items: center;
      cursor: pointer;
      margin-top: -10px;
      .more-img {
        margin-left: 4px;
      }
      .names {
        margin-left: 10px;
      }
    }
  }
}

.page-box {
  margin-top: 5px;
}
</style>